import { useMemo } from 'react'

import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

import { useI18n } from '../../../i18n/index.js'
import { ResultsView, SmartSearchEntityType } from '../../SmartSearch.types.js'

type Props = {
  type?: SmartSearchEntityType | 'trending-posts'
  title?: string
  className?: string
  view: ResultsView
}

export const SectionTitle = ({
  type,
  title: titleProp,
  className,
  view,
}: Props) => {
  const { $t } = useI18n()

  const title = useMemo(() => {
    if (titleProp) {
      return titleProp
    }

    switch (type) {
      case SmartSearchEntityType.OFFICIAL_POSTS:
        return $t({
          defaultMessage: 'Official Resources',
          id: 'Generics.OfficialResources',
        })
      case SmartSearchEntityType.POSTS:
        return $t({
          defaultMessage: 'Posts',
          id: 'Generics.Posts',
        })
      case SmartSearchEntityType.EVENTS:
        return $t({
          defaultMessage: 'Events',
          id: 'Generics.Events',
        })
      case SmartSearchEntityType.SPACES:
        return $t({
          defaultMessage: '{SPACES_CC}',
          id: 'Generics.Spaces',
        })
      case SmartSearchEntityType.MEMBERS:
        return $t({
          id: 'Generics.Members',
          defaultMessage: '{MEMBERS_CC}',
        })
      case SmartSearchEntityType.EXTERNALS:
        return $t({
          id: 'Generics.KnowledgeBase',
          defaultMessage: 'Knowledge base',
        })
      default:
        return null
    }
  }, [$t, type, titleProp])

  return (
    <li
      className={twMerge(
        clsx(
          'list-none text-content-subdued sticky top-0 bg-surface z-10 px-4 lg:px-5 pt-4 pb-2',
          className,
          {
            'text-sm font-medium': view === 'command-bar',
            'text-md font-medium': view === 'search-page',
          },
        ),
      )}
    >
      {title}
    </li>
  )
}
